import { EmploymentFields } from 'src/non-financial-data/v2/sections/fields/EmploymentFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function EmploymentV2() {
  return (
    <IndividualEntityForm title="Employment">
      <EmploymentFields />
    </IndividualEntityForm>
  );
}
